import {BaseAppModel} from "@/model/AppModel";
import {default as Tunit} from "@/module/thing/Unit";

export default class Unit extends BaseAppModel<Unit> implements Tunit {
    name!: string
    symbol!: string
}